export default __webpack_public_path__ + "static/media/close.6e2aaf53.svg";